import { merge } from 'theme-ui';

import { theme, type Theme } from '../theme';

import { buttons } from './buttons';
import { legacyThemeOverrides, sunriseColors } from './colors';
import { gradient } from './gradients';
import { radii } from './radii';
import { shadows } from './shadows';
import { space as sunriseSpace } from './space';

const colors = {
	...theme.colors,
	sunrise: {
		gradient: {
			...gradient,
			icon: "url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'><linearGradient id='icon-gradient' gradientTransform='rotate(-90, 0.5, 0.5)'><stop offset='0%' stop-color='%23FE9311'/><stop offset='100%' stop-color='%23FFDB00'/></linearGradient></svg>#icon-gradient\")", // orange.500 to yellow.400
		},
		...sunriseColors,
	},
	...legacyThemeOverrides,
};

const fonts = {
	body: '"Commissioner", "Helvetica Neue", Helvetica, Arial, Tahoma, sans-serif',
	heading: '"Commissioner", "Helvetica Neue", Helvetica, Arial, Tahoma, sans-serif',
	serif: '"Merriweather", serif',
};

const space = {
	// eslint-disable-next-line @typescript-eslint/no-misused-spread -- existing theme.space values are a record, not array
	...theme.space,
	...sunriseSpace,
};

export const sunriseTheme: (baseTheme: Theme) => Theme = (baseTheme) => {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
	return {
		...merge(baseTheme, {
			colors,
			fonts,
			radii,
			shadows,
			space,
		}),
		buttons,
	} as Theme;
};
